import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MobileUser } from '../models/mobile-user.model';
import { MobileUserCreateInput } from '../models/mobile-user-create-input.model';
import { MobileUserUpdateInput } from '../models/mobile-user-update-input.model';

export interface IMobileUsersRepository {
  list(organizationId: number): Observable<readonly MobileUser[]>;
  create(organizationId: number, input: MobileUserCreateInput): Observable<MobileUser>;
  update(organizationId: number, id: number, input: MobileUserUpdateInput): Observable<MobileUser>;
  deactivate(organizationId: number, id: number): Observable<void>;
  resendInvitation(organizationId: number, id: number): Observable<void>;
}

export const MOBILE_USERS_REPOSITORY = new InjectionToken<IMobileUsersRepository>('IMobileUsersRepository');
